<template>
  <email-compose-card
    v-if="currentCase"
    :caseTitle="currentCase.title"
    :title="title"
    :emailWindowToggled="emailWindowToggled"
    :allParticipants="allParticipants"
    :allBodyTemplates="allBodyTemplates"
    :currentCase="currentCase"
    :user="user"
    :replyMode="replyMode"
    :conversationSubject="conversationSubject"
    :conversationId="conversationId"
    :currentRecipients="currentRecipients"
    :currentRecipientsCc="currentRecipientsCc"
    :currentRecipientsBcc="currentRecipientsBcc"
  ></email-compose-card>
</template>
<script>
import { mapState } from "vuex";
import EmailComposeCard from "@/components/comms/EmailComposeCard";

export default {
  name: "Email-Window",
  components: { EmailComposeCard },
  data: () => ({
    fullscreenToggled: false,
    minimiseToggled: false,
    compose: true,
  }),
  computed: {
    allParticipants() {
      return this.emailWindowCtx.allParticipants;
    },
    allBodyTemplates() {
      console.log('emailWindowCtx', this.emailWindowCtx)
      console.log('allBodyTemplates', this.emailWindowCtx.allBodyTemplates)
      return this.emailWindowCtx.allBodyTemplates;
    },
    replyMode() {
      return !!this.emailWindowCtx.conversationId;
    },
    currentRecipients() {
      return this.emailWindowCtx.currentRecipients;
    },
    currentRecipientsCc() {
      return this.emailWindowCtx.currentRecipientsCc;
    },
    currentRecipientsBcc() {
      return this.emailWindowCtx.currentRecipientsBcc;
    },
    currentCase() {
      return this.emailWindowCtx.currentCase;
    },
    conversationId() {
      return this.emailWindowCtx.conversationId;
    },
    conversationSubject() {
      return this.emailWindowCtx.conversationSubject;
    },
    title() {
      return "New Message";
      // return this.emailWindowCtx.title || "New Message";
    },
  },
  props: {
    emailWindowToggled: {
      type: Boolean,
      default: false,
    },
    emailWindowCtx: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
};

function openWin() {
  var divText = document.getElementById("pass").outerHTML;
  var myWindow = window.open("", "", "width=200,height=100");
  var doc = myWindow.document;
  doc.open();
  doc.write(divText);
  doc.close();
}
</script>
<style>
.fixed-email-window {
  position: fixed !important;
  bottom: 0;
  right: 24px;
  width: 100%;
  max-width: 700px;
  /* height: 72vh;
  min-height: 500px; */
  background: grey;
  z-index: 999;
  display: none;
}

.fixed-email-window .theme--dark.v-chip {
        background: rgba(0, 0, 0, 0.12) !important;
      color: rgba(0,0,0,0.87);
}

.fixed-email-window .theme--dark .v-chip__content {
      height: 26px;
}

    .fixed-email-window .theme--dark.v-chip__close {
     margin: 0 0px 0 8px;
}

.message-container {
  height: calc(50vh - 64px);
  min-height: 436px;
  overflow: auto;
}

.fixed-email-window.show {
  display: block;
}

.fixed-email-window.fullscreen {
  width: 100%;
  max-width: 100%;
  right: 0;
  height: 100vh;
  transform: translateY(0) !important;
}

.fullscreen .message-container {
  height: calc(100vh - 64px);
  min-height: 436px;
  overflow: auto;
}

.fixed-email-window.minimise {
  transform: translateY(calc(100% - 64px));
}

.fixed-email-window .editr {
  margin-top:10px;
}

.fixed-email-window .editr--content {
  height: 260px;
  min-height: 260px;
}

.fixed-email-window.fullscreen .editr--content {
  height: calc(100vh - 450px);
}

.no-margin-bottom .v-text-field__details {
  display:none;
}

.custom-label {
  padding-top:0 !important;
  margin-top:0 !important;
}

.custom-label.v-text-field .v-label {
    top: 20%;
    transform: translateY(0px) scale(1) !important;

}

.custom-label.v-text-field .v-select__selections {
  padding:0 0 0 30px;
  min-height:45px;
}

.custom-label.v-text-field .v-select__selections .v-chip {
  margin:0px 5px 0 0 !important;
}

.custom-label.v-text-field.v-autocomplete.v-input > .v-input__control > .v-input__slot {
    min-height: 35px;
}


.custom-label.with-btns.v-text-field .v-select__selections {
  padding:0 65px 0 30px;
}

.custom-label.with-btns .v-input__append-outer {
  margin-left:0px !important;
}

.custom-label.text.v-text-field .v-select__selections {
  padding:0 0 0 0;
}

.custom-label.text.v-text-field .v-text-field__slot {
 height:35px;
}

.custom-label.text.v-text-field.v-input--is-dirty .v-label  {
  display:none;
}

.custom-label.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: rgba(0,0,0,0.22) !important;
}

.cc-bcc-buttons {
  width:60px;
  margin-left:-60px;
  Z-index:999;
  position:relative;
  text-align:right;
      margin-top: 6px;
}

.cc-bcc {
    opacity:0.52;
    display:inline-block;
    cursor:pointer;
}

.cc-bcc:hover {
  text-decoration:underline;
}

.subject-input.v-text-field .v-label {
  top: 20%;
  transform: translateY(0px) scale(1) !important;
}
</style>
